const menuRouter = [
    /**
     * 采购管理
     **/
    {
        path: '/operations/applyfor',
        meta: { title: '运维申请单' },
        component: () => import('@/views/page/operations/applyfor'),
        used: true,
    },
    {
        path: '/operations/acceptance',
        meta: { title: '运维确认' },
        component: () => import('@/views/page/operations/acceptance'),
        used: true,
    },
    {
        path: '/operations/dispatch',
        meta: { title: '运维派工单' },
        component: () => import('@/views/page/operations/dispatch'),
        used: true,
    },
    {
        path: '/operations/handling',
        meta: { title: '运维处理单' },
        component: () => import('@/views/page/operations/handling'),
        used: true,
    },
    {
        path: '/operations/followup',
        meta: { title: '运维回访单' },
        component: () => import('@/views/page/operations/followup'),
        used: true,
    },
    {
        path: '/operations/followupinfo',
        meta: { title: '客户回访登记' },
        component: () => import('@/views/page/operations/followupinfo'),
        used: true,
    },
    {
        path: '/operations/followupstat',
        meta: { title: '客户回访查询' },
        component: () => import('@/views/page/operations/followupstat'),
        used: true,
    }
]

export default menuRouter
